/**
 * Route copy for `src/routes/aiActivity` (keys: `routes.aiActivity.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  aIActivityPage: {
    outOfTotal: 'of {{total}} in total',
    noFinishedRun: 'no finished run',
    run: 'Run',
    type: 'Type',
    status: 'Status',
    progress: 'Progress',
    tokens: 'Tokens',
    cost: 'Cost',
    duration: 'Duration',
    created: 'Created',
    theAiOrchestratorServiceIsUnreachable: 'The ai-orchestrator service is unreachable. Retrying in 3 s…',
    couldNotChangeTheCircuitBreaker: 'Could not change the circuit breaker.',
    aiActivity: 'AI activity',
    live: 'live',
    agentRunsInRealTimeRefreshed: 'Agent runs in real time (refreshed every 3 s).',
    killSwitchActiveNewRunsRefused: '⛔ Kill switch active — new runs refused',
    reEnableAiRuns: 'Re-enable AI runs',
    enableTheKillSwitch: 'Enable the kill switch',
    activeRuns: 'Active runs',
    completed: 'Completed',
    failures: 'Failures',
    totalCost: 'Total cost',
    filterByStatus: 'Filter by status',
    allStatuses: 'All statuses',
    filterByType: 'Filter by type',
    allTypes: 'All types',
    searchByRunOrUserId: 'Search by run or user id…',
    searchARun: 'Search a run',
    reset: 'Reset',
    run2: 'run',
    shown: 'shown',
    noRunMatchesTheFilters: 'No run matches the filters.',
    loading: 'Loading…',
    enableTheAiKillSwitch: 'Enable the AI kill switch?',
    killSwitchForTheDefaultTenant: 'Kill switch for the “default” tenant. Every new AI run will be refused while it is active.',
    successRate: 'success rate',
  },
  confirmDialog: {
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  format: {
    mMinVS: '{{m}} min {{v}} s',
    vHV2Min: '{{v}} h {{v2}} min',
    justNow: 'just now',
    sSAgo: '{{s}} s ago',
    mMinAgo: '{{m}} min ago',
    hHAgo: '{{h}} h ago',
    vDAgo: '{{v}} d ago',
    queued: 'queued',
    inProgress: 'in progress',
    awaitingApproval: 'awaiting approval',
    paused: 'paused',
    insufficientCredits: 'insufficient credits',
    completed: 'completed',
    failed: 'failed',
    cancelled: 'cancelled',
    skipped: 'skipped',
  },
  runDetailModal: {
    couldNotLoadTheRunDetails: 'Could not load the run details.',
    stoppingTheRunFailed: 'Stopping the run failed.',
    runDetailsRunid: 'Run details {{runId}}',
    stopping: 'Stopping…',
    stop: 'Stop',
    close: 'Close',
    runView: 'Run view',
    details: 'Details',
    graph: 'Graph',
    loading: 'Loading…',
    progress: 'progress',
    tokens: 'tokens',
    cost: 'cost',
    duration: 'duration',
    inputV: 'input {{v}}',
    user: 'User',
    tenant: 'Tenant',
    created: 'Created',
    duration2: 'Duration',
    tokensIn: 'Tokens in',
    tokensOut: 'Tokens out',
    cost2: 'Cost',
    progress2: 'Progress',
    error: 'Error',
    inputJson: 'Input JSON',
    outputJson: 'Output JSON',
    stepsV: 'Steps ({{v}})',
    noStepsYet: 'No steps yet.',
    reasoning: 'Reasoning',
    input: 'Input',
    output: 'Output',
    loadingTheGraph: 'Loading the graph…',
    stopThisRun: 'Stop this run?',
    stepsInProgressWillBeInterrupted: 'Steps in progress will be interrupted.',
    stopTheRun: 'Stop the run',
  },
  runGraph: {
    inProgress: 'in progress',
    completed: 'completed',
    failed: 'failed',
    skipped: 'skipped',
    noStepRunForThisRun: 'No step run for this run (the graph appears from the first node).',
    step: 'step',
    runExecutionGraph: 'Run execution graph',
  },
};

export default en;
